module.exports = __webpack_public_path__ + "static/media/Boxsteelsection.cd869f50.svg";